import * as nsVue from 'vue'
import { Vue, Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import { Node } from "../models"
import App from '../App'
// import TreeItem from './parts/TreeItem'
import { liset } from "../utils";
import hyper from '../hyper'

let TreeItem: nsVue.FunctionalComponentOptions = {
  functional: true,
  props: ['root', 'tracks', 'portal'],
  render(createElement, ctx) {
    let { e, ul, li, a, span, i } = hyper(createElement)
    let root = ctx.props.root as Node
    let tracks = ctx.props.tracks as number[]
    let portal = ctx.props.portal as string
    let cid = parseInt(ctx.parent.$route.params.nodeId)
    function c(node: Node, level: number) {
      let active$ = node.id === cid
      let itemType = (ctx.parent.$root.$children[0] as App).itemDefinitions.map[node.type]
      let to = {
        name: itemType ? 'portal-item-list' : 'portal-template',
        params: {
          portalKey: portal,
          nodeId: node.id.toString()
        }
      }
      let show = level===0 || tracks.indexOf(node.id)!==-1
      let href = ctx.parent.$router.resolve(to).href
      let $click = function (event: Event) {
        liset.toggle(tracks, node.id)
        event.stopPropagation()
        event.preventDefault()
      }
      let ownChild = node.children.length !== 0
      let showIcon = level !== 0 && ownChild
      let padding = (8 + 14 * level * 2) + 'px'
      return li([
        a({class: 'row', active$, href, borderLeftWidth$$: padding}, [
          !showIcon?e: i({$click}, show?'[-]':'[+]'),
          node.name
        ]),
        !ownChild?e: ul({show}, node.children.map(n=>c(n, level+1)))
      ])
    }
    return c(root, 0)
  }
}

@Component({
  name: 'Portal',
  components: { TreeItem }
})
export default class Portal extends Vue {
  portalKey: string = ""

  tracks: number[] = []
  
  root: Node | null = null;

  created() {
    this.reset()
  }

  @Watch('$route')
  $routeChanged() {
    this.reset()
  }

  private async reset() {
    let portalKey = this.$route.params.portalKey
    if (this.portalKey !== portalKey) {
      this.root = null
      this.root = await (this.$root.$children[0] as App).getPortalRoot(portalKey)
      this.portalKey = portalKey
    }
    if (!this.root)
      throw new Error('inconsistent.')
    if (this.$route.name === 'portal') {
      let itemType = (this.$root.$children[0] as App).itemDefinitions.map[this.root!.type] 
      let location = {
        name: itemType ? 'portal-item-list' : 'portal-template',
        params: {
          portalKey: this.$route.params.portalKey,
          nodeId: this.root!.id.toString()
        }
      }
      this.$router.replace(location)
    }
    else if (this.$route.params.nodeId) {
      let nodeId = parseInt(this.$route.params.nodeId)
      let nodePath = getNodePath(this.root!, nodeId)
      for (let node of nodePath) {
        liset.add(this.tracks, node.id)
      }
    }
  }
}

function getNodePath(root: Node, id: number) {
  let stack: Node[] = []
  function _m(node: Node) {
    if (node.id === id) {
      stack.push(node)
      return true
    }
    else {
      if (node.children.length !== 0) {
        stack.push(node)
        for (var child of node.children) {
          if (_m(child))
            return true
        }
        stack.pop()
      }
      else
        return false
    }
  }
  _m(root)
  return stack
}
